<template>
  <b-card
      title="مدیریت لینک ها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div>
          <b-row>
            <div class="filter-row float-left">
              <b-button
                  class="mb-1 mr-auto"
                  variant="primary"
                  @click="makeNewRedirect"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="Url"
                    label-for="Url"
                >
                  <b-form-input
                      v-model="filterOptions.Url"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="RedirectUrl"
                    label-for="RedirectUrl"
                >
                  <b-form-input
                      v-model="filterOptions.RedirectUrl"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>

              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
                :to="{ name: 'updateblogcategory', params: { id: data.value }}"
                class="font-weight-bold "
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Url)="data">
            <p class="dir-ltr text-left m-0">
              <span class="d-block" style="width: fit-content"> {{ data.value }} </span>
            </p>
          </template>
<template #cell(RedirectUrl)="data">
  <p class="dir-ltr text-left m-0">
    <span class="d-block" style="width: fit-content"> {{ data.value }} </span>
  </p>
</template>
          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
                <feather-icon
                    :id="`invoice-row-${data.item.Id}-send-icon`"
                    icon="EditIcon"
                    size="16"
                    @click="showEditModal(data)"
                />
              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="removeRow($api.blogcategory.removeRedirect, 'Id', data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />

      </b-col>
      <b-modal
          v-model="showRedirectModal"
          ok-title="ذخیره"
          cancel-title="انصراف"
          cancel-variant="outline-secondary"
          centered
          title="redirect"
          :no-close-on-backdrop="true"
          size="sm"
          @ok="addNewRedirect"
          @close="closeModal"
          @hidden="closeModal"
          @cancel="closeModal"
      >
        <b-row>
          <b-col md="12" class="text-left">
            <b-form-group
                label="Url"
                label-for="Url"
            >
              <b-form-input
                  id="Alt"
                  v-model="tempURL"
                  name="Title"
                  autocomplete="off"
                  dir="ltr"
              />
            </b-form-group>
             <b-form-group
                label="redirect Url"
                label-for="Url"
            >
              <b-form-input
                  id="Alt"
                  v-model="tempRedirectURL"
                  name="Title"
                  autocomplete="off"
                  dir="ltr"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-modal>
    </b-row>

  </b-card>
</template>

<script>
export default {
  name: 'blogRedirect',
  data() {
    return {
      totalRows: 0,
      loading: false,
      filterOptions: {
        Url: null,
        RedirectUrl: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Url',
          label: 'Url',
        },
          {
          key: 'RedirectUrl',
          label: 'Redirect Url',
        },

        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      showRedirectModal: false,
      tempRedirectURL: null,
      tempURL: null,
      tempId:null,
      api: ''
    }
  },
  watch:{
    tempURL(val){
      const regex = /^(http:\/\/)|(https:\/\/)/gm;
      this.tempURL = decodeURIComponent(val.replace(regex, ''))
    },
    tempRedirectURL(val){
      const regex = /^(http:\/\/)|(https:\/\/)/gm;
      this.tempRedirectURL = decodeURIComponent(val.replace(regex, ''))
    },
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$http.post(
          this.$api.blogcategory.redirectList, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    remove(id) {
      this.removeRow(this.$api.blogcategory.removeUrl, 'Id', id)
    },
    closeModal(){
      this.api = ''
      this.tempRedirectURL = ''
      this.tempURL = ''
      this.tempId = ''
    },
    showEditModal(data){
      this.api = this.$api.blogcategory.updateRedirect
      this.tempURL = data.item.Url
      this.tempId= data.item.Id
      this.tempRedirectURL = data.item.RedirectUrl
      this.showRedirectModal = true
    },
    makeNewRedirect(){
      this.api = this.$api.blogcategory.addRedirect
      this.showRedirectModal = true
    },
    addNewRedirect(e){
      e.preventDefault()
      this.$http.post(this.api,{
        Id:this.tempId,
        Url: this.tempURL,
        RedirectUrl: this.tempRedirectURL
      }).then(()=>{
        this.showRedirectModal = false
        this.update()
      })
    },
  },
}
</script>

<style scoped>

</style>
